import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import {
  ChargeInputDirective,
  ColumnLayoutDirective,
  GlobalModalDirective,
  InputTrimDirective,
  KeepStateDirective,
  OpenPdfDirective,
  ShowAuthedDirective,
  ShowForRoleDirective
} from './directives';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpApiVersionInterceptor, HttpRefreshTokenInterceptor, HttpTokenInterceptor } from './interceptors';
import { NzModalModule } from 'ng-zorro-antd/modal';
import {
  DateFormatPipe,
  BooleanFormatPipe,
  StatusFormatPipe,
  GetVariantsWithoutLabelPipe,
  SortMinutesAndHoursSelectOptionsPipe,
  DateTimeFormatPipe,
  ProductionUnitsFormatPipe,
  StockByStorePipe,
  MainStoreNameByStocksPipe,
  ProductionUnitFormatPipe,
  StringIncludesPipe,
  QueryParamsPipe,
  RouterLinkPipe,
  IsStoreMainOrBbmPipe,
  MainStoreSlnPipe,
  SupplierTooltipPipe,
  StoreNameByIdPipe,
  ParseFloatPipe, ArticleVariantSaleHistoryItemByStorePipe, NumberToCurrencyPipe,
  ExportTypeLabelPipe, ExportDocumentNamePipe, RoleLabelPipe
} from './pipes';

import { PossitiveNumbersDirective } from './directives/possitive-numbers.directive';
import { DownloadFileUrlPipe } from './pipes/download-file-url.pipe';
import { TimeFormatPipe } from './pipes/time-format.pipe';
import { DurationFormatPipe } from './pipes/duration-format.pipe';
import { MapToArrayPipe } from './pipes/map-to-array.pipe';
import { TextInputOnlyNumbersDirective } from './directives/text-input-only-numbers.directive';
import { DragBackgroundPositionDirective } from './directives/drag-background-position.directive';
import { DateRangeSalesHistoryStoreItemPipe } from './pipes/date-range-sales-history-store-item.pipe';



@NgModule({
  declarations: [
    ShowAuthedDirective,
    ShowForRoleDirective,
    GlobalModalDirective,
    DateFormatPipe,
    DateTimeFormatPipe,
    BooleanFormatPipe,
    StatusFormatPipe,
    KeepStateDirective,
    ColumnLayoutDirective,
    PossitiveNumbersDirective,
    DownloadFileUrlPipe,
    GetVariantsWithoutLabelPipe,
    TimeFormatPipe,
    DurationFormatPipe,
    MapToArrayPipe,
    TextInputOnlyNumbersDirective,
    DragBackgroundPositionDirective,
    SortMinutesAndHoursSelectOptionsPipe,
    InputTrimDirective,
    ProductionUnitsFormatPipe,
    StockByStorePipe,
    MainStoreNameByStocksPipe,
    ProductionUnitFormatPipe,
    StringIncludesPipe,
    ChargeInputDirective,
    OpenPdfDirective,
    QueryParamsPipe,
    RouterLinkPipe,
    SupplierTooltipPipe,
    RouterLinkPipe,
    IsStoreMainOrBbmPipe,
    MainStoreSlnPipe,
    StoreNameByIdPipe,
    ParseFloatPipe,
    ArticleVariantSaleHistoryItemByStorePipe,
    NumberToCurrencyPipe,
    DateRangeSalesHistoryStoreItemPipe,
    ExportTypeLabelPipe,
    ExportDocumentNamePipe,
    RoleLabelPipe
  ],
  imports: [
    CommonModule,
    NzModalModule,
  ],
  exports: [
    ShowAuthedDirective,
    ShowForRoleDirective,
    GlobalModalDirective,
    DateTimeFormatPipe,
    DateFormatPipe,
    BooleanFormatPipe,
    StatusFormatPipe,
    KeepStateDirective,
    ColumnLayoutDirective,
    PossitiveNumbersDirective,
    DownloadFileUrlPipe,
    GetVariantsWithoutLabelPipe,
    TimeFormatPipe,
    DurationFormatPipe,
    MapToArrayPipe,
    TextInputOnlyNumbersDirective,
    DragBackgroundPositionDirective,
    DragBackgroundPositionDirective,
    SortMinutesAndHoursSelectOptionsPipe,
    InputTrimDirective,
    ProductionUnitsFormatPipe,
    StockByStorePipe,
    MainStoreNameByStocksPipe,
    ProductionUnitFormatPipe,
    StringIncludesPipe,
    ChargeInputDirective,
    OpenPdfDirective,
    RouterLinkPipe,
    QueryParamsPipe,
    IsStoreMainOrBbmPipe,
    MainStoreSlnPipe,
    SupplierTooltipPipe,
    StoreNameByIdPipe,
    ParseFloatPipe,
    ArticleVariantSaleHistoryItemByStorePipe,
    NumberToCurrencyPipe,
    DateRangeSalesHistoryStoreItemPipe,
    ExportTypeLabelPipe,
    ExportDocumentNamePipe,
    RoleLabelPipe,
  ],
  providers: [
    DecimalPipe,
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpRefreshTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpApiVersionInterceptor, multi: true },
  ]
})
export class CoreModule { }
